module.exports = __webpack_public_path__ + "img/home.9466c922.svg";